import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import API from '../../utils/api';
import toast from 'react-hot-toast';
import { format, subDays } from 'date-fns';
import { es } from 'date-fns/locale';

const COP = (n) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(Number(n) || 0);
const num = (v) => parseFloat(v) || 0;

export default function CuadreIngresos() {
  const hoy = format(new Date(), 'yyyy-MM-dd');

  const [bodegas, setBodegas]   = useState([]);
  const [bodegaId, setBodegaId] = useState('');
  const [fecha, setFecha]       = useState(hoy);
  const [datos, setDatos]       = useState(null);
  const [cargando, setCargando] = useState(false);
  const [vistaTab, setVistaTab] = useState('cuadre'); // 'cuadre' | 'historial'
  const [historial, setHistorial] = useState([]);
  const [cargandoHist, setCargandoHist] = useState(false);
  const hoyDate = new Date();
  const [desde, setDesde] = useState(format(new Date(hoyDate.getFullYear(), hoyDate.getMonth(), 1), 'yyyy-MM-dd'));
  const [hasta, setHasta] = useState(hoy);

  useEffect(() => {
    API.get('/bodegas').then(r => {
      const pvs = r.data.filter(b => b.tipo === 'punto_venta');
      setBodegas(pvs);
      if (pvs.length) setBodegaId(String(pvs[0].id));
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!bodegaId) return;
    cargar();
  }, [bodegaId, fecha]);

  const cargar = () => {
    setCargando(true);
    setDatos(null);
    API.get('/cuadre-ingresos', { params: { bodega_id: bodegaId, fecha } })
      .then(r => setDatos(r.data))
      .catch(() => toast.error('Error cargando cuadre'))
      .finally(() => setCargando(false));
  };

  const cargarHistorial = () => {
    if (!bodegaId) return;
    setCargandoHist(true);
    API.get('/cuadre-ingresos/historial', { params: { bodega_id: bodegaId, desde, hasta } })
      .then(r => setHistorial(r.data))
      .catch(() => toast.error('Error cargando historial'))
      .finally(() => setCargandoHist(false));
  };

  useEffect(() => {
    if (vistaTab === 'historial' && bodegaId) cargarHistorial();
  }, [vistaTab, bodegaId, desde, hasta]);

  const descargarCSV = () => {
    if (!historial.length) return;
    const COP2 = (n) => Math.round(parseFloat(n)||0);
    const headers = ['Fecha','Estado','Efectivo ventas','Entradas','Salidas','Esperado','Real contado','Diferencia','Observaciones'];
    const rows = historial.map(h => [
      h.fecha, h.estado, COP2(h.efectivo_ventas), COP2(h.entradas),
      COP2(h.salidas), COP2(h.esperado), COP2(h.real), COP2(h.diferencia),
      h.observaciones || ''
    ]);
    const csv = [headers, ...rows].map(r => r.join(',')).join('\n');
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url;
    a.download = `cuadre_efectivo_${bodegaNombre}_${desde}_${hasta}.csv`;
    a.click(); URL.revokeObjectURL(url);
  };

  const bodegaNombre = bodegas.find(b => String(b.id) === String(bodegaId))?.nombre || '';
  const cuadra = datos?.caja ? Math.abs(datos.caja.diferencia) < 100 : null;

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", maxWidth: 1080, margin: '0 auto' }}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: '#111827' }}>💰 Cuadre de Ingresos</h1>
        <p style={{ margin: '4px 0 0', color: '#6B7280', fontSize: 14 }}>Conciliación de ventas por medio de pago — {bodegaNombre}</p>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', background:'#F3F4F6', borderRadius:8, padding:2, width:'fit-content', marginBottom:16 }}>
        {[{id:'cuadre',label:'📊 Cuadre diario'},{id:'historial',label:'📅 Historial'}].map(t => (
          <button key={t.id} onClick={() => setVistaTab(t.id)} style={{
            padding:'7px 18px', border:'none', borderRadius:7, cursor:'pointer', fontSize:13,
            fontWeight: vistaTab===t.id?700:500,
            background: vistaTab===t.id?'white':'transparent',
            color: vistaTab===t.id?'#111827':'#6B7280',
            boxShadow: vistaTab===t.id?'0 1px 3px rgba(0,0,0,0.1)':'none'
          }}>{t.label}</button>
        ))}
      </div>

      <div style={{ background: 'white', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 18, display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div>
          <div style={st.label}>Punto de venta</div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {bodegas.map(b => (
              <button key={b.id} onClick={() => setBodegaId(String(b.id))} style={{
                padding: '8px 16px', border: '2px solid', borderRadius: 20, cursor: 'pointer', fontSize: 13, fontWeight: 600,
                borderColor: String(bodegaId) === String(b.id) ? '#1a1a2e' : '#E5E7EB',
                background: String(bodegaId) === String(b.id) ? '#1a1a2e' : 'white',
                color: String(bodegaId) === String(b.id) ? 'white' : '#6B7280',
              }}>🏪 {b.nombre}</button>
            ))}
          </div>
        </div>
        {vistaTab === 'cuadre' && (
          <>
            <div>
              <div style={st.label}>Fecha</div>
              <input type="date" value={fecha} onChange={e => setFecha(e.target.value)} max={hoy} style={st.input} />
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              {['Hoy', 'Ayer'].map((label, i) => (
                <button key={label} onClick={() => setFecha(format(subDays(new Date(), i), 'yyyy-MM-dd'))}
                  style={{ padding: '8px 14px', border: '2px solid #E5E7EB', borderRadius: 8, background: 'white', cursor: 'pointer', fontSize: 12, fontWeight: 600, color: '#6B7280' }}>
                  {label}
                </button>
              ))}
            </div>
          </>
        )}
        {vistaTab === 'historial' && (
          <>
            <div>
              <div style={st.label}>Desde</div>
              <input type="date" value={desde} onChange={e => setDesde(e.target.value)} max={hasta} style={st.input} />
            </div>
            <div>
              <div style={st.label}>Hasta</div>
              <input type="date" value={hasta} onChange={e => setHasta(e.target.value)} max={hoy} style={st.input} />
            </div>
          </>
        )}
        {cargando && <span style={{ fontSize: 13, color: '#6B7280', alignSelf: 'center' }}>⏳ Calculando...</span>}
      </div>

      {vistaTab === 'cuadre' && datos && (
        <>
          {!datos.caja ? (
            <div style={{ background: '#FEF3C7', border: '1px solid #FCD34D', borderRadius: 12, padding: '14px 18px', marginBottom: 16, fontSize: 13, color: '#92400E', fontWeight: 600 }}>
              ⚠️ El PDV aún no ha llenado el cierre de caja para esta fecha
            </div>
          ) : (
            <div style={{
              background: cuadra ? '#D1FAE5' : datos.caja.diferencia < 0 ? '#FEE2E2' : '#FEF3C7',
              border: `1px solid ${cuadra ? '#6EE7B7' : datos.caja.diferencia < 0 ? '#FECACA' : '#FCD34D'}`,
              borderRadius: 12, padding: '14px 20px', marginBottom: 16,
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12
            }}>
              <div style={{ fontWeight: 800, fontSize: 15, color: cuadra ? '#065F46' : datos.caja.diferencia < 0 ? '#991B1B' : '#92400E' }}>
                {cuadra ? '✅ Cuadra' : datos.caja.diferencia < 0 ? '❌ Faltante' : '⚠️ Sobrante'}
                {' — '}
                <span style={{ fontFamily: 'monospace', fontSize: 18 }}>
                  {datos.caja.diferencia > 0 ? '+' : ''}{COP(datos.caja.diferencia)}
                </span>
              </div>
              <div style={{ fontSize: 13, color: '#6B7280' }}>
                Cierre: <strong style={{ textTransform: 'capitalize' }}>{datos.caja.estado}</strong>
                {' · '}{bodegaNombre}
                {' · '}{fecha ? format(new Date(fecha + 'T12:00'), "d 'de' MMMM yyyy", { locale: es }) : ''}
              </div>
            </div>
          )}

          {/* Tabla conciliación */}
          <div style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 16 }}>
            <div style={{ background: '#1a1a2e', padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'white', fontWeight: 800, fontSize: 14 }}>📊 Conciliación por medio de pago</span>
              <span style={{ color: 'rgba(255,255,255,0.7)', fontFamily: 'monospace', fontWeight: 700 }}>
                Total: {COP(datos.totales.total_ventas)}
              </span>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#F9FAFB' }}>
                  {['Medio de pago', 'Aliaddo', 'POS Emergencia', 'Total', 'Destino'].map(h => (
                    <th key={h} style={{ padding: '10px 16px', textAlign: h === 'Medio de pago' || h === 'Destino' ? 'left' : 'right', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  { label: '💵 Efectivo',           al: datos.aliaddo.efectivo,         pos: datos.pos.efectivo,  total: datos.totales.efectivo,                               destino: 'Caja — va al banco',      color: '#10B981', importante: true },
                  { label: '💳 Tarjeta débito',      al: datos.aliaddo.tarjeta_debito,   pos: datos.pos.tarjeta,   total: datos.aliaddo.tarjeta_debito + datos.pos.tarjeta,     destino: 'Datafono → cuenta',       color: '#3B82F6' },
                  { label: '💳 Tarjeta crédito',     al: datos.aliaddo.tarjeta_credito,  pos: 0,                   total: datos.aliaddo.tarjeta_credito,                        destino: 'Datafono → cuenta',       color: '#6366F1' },
                  { label: '📱 Nequi',               al: datos.aliaddo.nequi,            pos: datos.pos.qr,        total: (datos.aliaddo.nequi||0) + (datos.pos.qr||0),         destino: 'Cuenta bancaria',         color: '#0EA5E9' },
                  { label: '🏦 Transferencias',      al: datos.aliaddo.transferencias,   pos: 0,                   total: datos.aliaddo.transferencias||0,                      destino: 'Cuenta bancaria',         color: '#0284C7' },
                  { label: '📲 Daviplata / Dale',    al: datos.aliaddo.daviplata,        pos: 0,                   total: datos.aliaddo.daviplata||0,                           destino: 'Cuenta bancaria',         color: '#7C3AED' },
                  { label: '🛵 Rappi',               al: datos.aliaddo.rappi,            pos: 0,                   total: datos.totales.rappi,                                  destino: 'Liquidación Rappi',       color: '#F97316' },
                  { label: '🎟️ Bonos Coomeva',      al: datos.aliaddo.bonos,            pos: 0,                   total: datos.totales.bonos,                                  destino: 'Liquidación Coomeva',     color: '#8B5CF6' },
                  { label: '🔀 Pago mixto',          al: datos.aliaddo.mixto,            pos: 0,                   total: datos.aliaddo.mixto,                                  destino: 'Verificar manualmente',   color: '#9CA3AF' },
                ].filter(r => r.total > 0).map((r, i) => (
                  <tr key={i} style={{ borderTop: '1px solid #F3F4F6', background: r.importante ? '#F0FDF4' : i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                    <td style={{ padding: '11px 16px', fontWeight: 700 }}>{r.label}</td>
                    <td style={{ padding: '11px 16px', textAlign: 'right', fontFamily: 'monospace', color: r.al > 0 ? '#111827' : '#D1D5DB' }}>{r.al > 0 ? COP(r.al) : '—'}</td>
                    <td style={{ padding: '11px 16px', textAlign: 'right', fontFamily: 'monospace', color: r.pos > 0 ? '#111827' : '#D1D5DB' }}>{r.pos > 0 ? COP(r.pos) : '—'}</td>
                    <td style={{ padding: '11px 16px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: r.color, fontSize: 14 }}>{COP(r.total)}</td>
                    <td style={{ padding: '11px 16px', fontSize: 12, color: '#6B7280' }}>{r.destino}</td>
                  </tr>
                ))}
                <tr style={{ borderTop: '2px solid #E5E7EB', background: '#F9FAFB' }}>
                  <td style={{ padding: '12px 16px', fontWeight: 800, fontSize: 14 }}>Total</td>
                  <td style={{ padding: '12px 16px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800 }}>{COP(datos.aliaddo.total)}</td>
                  <td style={{ padding: '12px 16px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800 }}>{COP(datos.pos.total)}</td>
                  <td style={{ padding: '12px 16px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, fontSize: 15, color: '#1a1a2e' }}>{COP(datos.totales.total_ventas)}</td>
                  <td style={{ padding: '12px 16px', fontSize: 12, color: '#9CA3AF' }}>{datos.aliaddo.facturas + datos.pos.ventas} transacciones</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Cuadre efectivo */}
          {datos.caja && (
            <div style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 16 }}>
              <div style={{ padding: '12px 20px', borderBottom: '1px solid #F3F4F6', fontWeight: 800, fontSize: 14 }}>💵 Cuadre de efectivo</div>
              <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 480 }}>
                <FilaCuadre label="Efectivo en ventas" valor={datos.totales.efectivo} signo="+" />
                <FilaCuadre label="Entradas de efectivo" valor={datos.caja.entradas} signo="+" />
                <FilaCuadre label="Salidas (compras + otros)" valor={datos.caja.salidas} signo="−" negativo />
                <div style={{ borderTop: '2px solid #F3F4F6', paddingTop: 10, display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontWeight: 700, color: '#6B7280' }}>Efectivo esperado</span>
                  <span style={{ fontFamily: 'monospace', fontWeight: 800, fontSize: 17 }}>{COP(datos.caja.efectivo_esperado)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontWeight: 700, color: '#6B7280' }}>Efectivo real contado</span>
                  <span style={{ fontFamily: 'monospace', fontWeight: 800, fontSize: 17 }}>{COP(datos.caja.efectivo_real)}</span>
                </div>
                <div style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '12px 16px', borderRadius: 10,
                  background: cuadra ? '#D1FAE5' : datos.caja.diferencia < 0 ? '#FEE2E2' : '#FEF3C7',
                  color: cuadra ? '#065F46' : datos.caja.diferencia < 0 ? '#991B1B' : '#92400E',
                }}>
                  <span style={{ fontWeight: 800 }}>{cuadra ? '✅ Cuadra' : datos.caja.diferencia < 0 ? '❌ Faltante' : '⚠️ Sobrante'}</span>
                  <span style={{ fontFamily: 'monospace', fontWeight: 800, fontSize: 22 }}>
                    {datos.caja.diferencia > 0 ? '+' : ''}{COP(datos.caja.diferencia)}
                  </span>
                </div>
              </div>
              {datos.caja.observaciones && (
                <div style={{ padding: '12px 20px', background: '#F9FAFB', borderTop: '1px solid #F3F4F6', fontSize: 13, color: '#6B7280' }}>
                  <strong>Observaciones PDV:</strong> {datos.caja.observaciones}
                </div>
              )}
            </div>
          )}
        </>
      )}

      {vistaTab === 'cuadre' && !cargando && !datos && (
        <div style={{ background: 'white', borderRadius: 14, padding: 40, textAlign: 'center', color: '#9CA3AF', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
          Selecciona un punto de venta para ver el cuadre.
        </div>
      )}

      {/* Historial */}
      {vistaTab === 'historial' && (
        <div style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
          <div style={{ background: '#1a1a2e', padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: 'white', fontWeight: 800, fontSize: 14 }}>📅 Historial de cuadres — {bodegaNombre}</span>
            <button onClick={descargarCSV} disabled={!historial.length}
              style={{ padding: '6px 14px', border: 'none', borderRadius: 8, background: historial.length ? '#10B981' : '#374151', color: 'white', cursor: historial.length ? 'pointer' : 'not-allowed', fontSize: 12, fontWeight: 700 }}>
              ⬇️ Descargar CSV
            </button>
          </div>
          {cargandoHist ? (
            <div style={{ padding: 32, textAlign: 'center', color: '#9CA3AF' }}>⏳ Cargando...</div>
          ) : historial.length === 0 ? (
            <div style={{ padding: 32, textAlign: 'center', color: '#9CA3AF' }}>Sin cierres en este período</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    {['Fecha','Estado','Efectivo ventas','Entradas','Salidas','Esperado','Real contado','Diferencia'].map(h => (
                      <th key={h} style={{ padding: '10px 14px', textAlign: h === 'Fecha' || h === 'Estado' ? 'left' : 'right', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {historial.map((h, i) => {
                    const dif = parseFloat(h.diferencia||0);
                    const cuadraH = Math.abs(dif) < 100;
                    const difColor = cuadraH ? '#10B981' : dif < 0 ? '#EF4444' : '#F59E0B';
                    return (
                      <tr key={h.fecha} style={{ borderTop: '1px solid #F3F4F6', background: i%2===0?'white':'#FAFAFA' }}>
                        <td style={{ padding: '10px 14px', fontWeight: 700 }}>
                          {format(new Date(h.fecha+'T12:00'), "d 'de' MMM yyyy", {locale:es})}
                        </td>
                        <td style={{ padding: '10px 14px' }}>
                          <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 700,
                            background: h.estado==='enviado'?'#DBEAFE':h.estado==='aprobado'?'#D1FAE5':'#F3F4F6',
                            color: h.estado==='enviado'?'#1E40AF':h.estado==='aprobado'?'#065F46':'#6B7280'
                          }}>{h.estado}</span>
                        </td>
                        <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', color: '#10B981', fontWeight: 600 }}>{COP(h.efectivo_ventas)}</td>
                        <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', color: h.entradas > 0 ? '#6366F1' : '#9CA3AF' }}>{h.entradas > 0 ? COP(h.entradas) : '—'}</td>
                        <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', color: h.salidas > 0 ? '#EF4444' : '#9CA3AF' }}>{h.salidas > 0 ? COP(h.salidas) : '—'}</td>
                        <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 700 }}>{COP(h.esperado)}</td>
                        <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800 }}>{COP(h.real)}</td>
                        <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: difColor }}>
                          {cuadraH ? '✅ 0' : `${dif > 0 ? '+' : ''}${COP(dif)}`}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr style={{ borderTop: '2px solid #E5E7EB', background: '#F9FAFB' }}>
                    <td colSpan={2} style={{ padding: '10px 14px', fontWeight: 800 }}>Total período</td>
                    <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: '#10B981' }}>{COP(historial.reduce((s,h) => s + parseFloat(h.efectivo_ventas||0), 0))}</td>
                    <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: '#6366F1' }}>{COP(historial.reduce((s,h) => s + parseFloat(h.entradas||0), 0))}</td>
                    <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: '#EF4444' }}>{COP(historial.reduce((s,h) => s + parseFloat(h.salidas||0), 0))}</td>
                    <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800 }}>{COP(historial.reduce((s,h) => s + parseFloat(h.esperado||0), 0))}</td>
                    <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800 }}>{COP(historial.reduce((s,h) => s + parseFloat(h.real||0), 0))}</td>
                    <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: (() => { const t = historial.reduce((s,h) => s + parseFloat(h.diferencia||0), 0); return Math.abs(t)<100?'#10B981':t<0?'#EF4444':'#F59E0B'; })() }}>
                      {(() => { const t = historial.reduce((s,h) => s + parseFloat(h.diferencia||0), 0); return `${t>0?'+':''}${COP(t)}`; })()}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function FilaCuadre({ label, valor, signo, negativo }) {
  if (!valor) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ fontSize: 13, color: '#6B7280' }}>
        <span style={{ fontWeight: 700, color: negativo ? '#EF4444' : '#10B981', marginRight: 6 }}>{signo}</span>
        {label}
      </span>
      <span style={{ fontFamily: 'monospace', fontWeight: 600, color: negativo ? '#EF4444' : '#111827' }}>{COP(valor)}</span>
    </div>
  );
}

const st = {
  label: { fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 },
  input: { padding: '8px 12px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 13, outline: 'none', background: 'white' },
};
